"use client";

// packages/eden-appearance/src/components/AppearanceContext.jsx
import { createContext } from "react";
var AppearanceContext = createContext();
export {
  AppearanceContext
};
